import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../contexts/GlobalState';
import RadioButtonComponent from '../../ui/RadioButtonComponent';
import ButtonGreen from './ButtonGreen';
import { useHome } from '../../contexts/HomeContext';
import Loader from '../../ui/Loader';
import RadioButtonComponentLandscapes from '../../ui/RadioButtonComponentLandscapes';
import DuplicateBountyModal from '../bounties/DuplicateBountyModal';

const SelectPrimaryPill = ({ foundPill, setFoundPill }) => {
    const [open, setOpen] = useState(false);
    const { state: homeState, dispatch, loading, gettingGreenpillCounts, putSelectedPill } = useHome();

    const { state: landscapesState } = useGlobalState();
    const { greenPillNFTsHoldByWalletAddress, greenPillNFTsCountInLandscapes } = homeState;

    const myRef = useRef();
    const { landscapes } = landscapesState;

    useEffect(() => {
        function handleClick(e) {
            if (myRef.current && !myRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('click', handleClick, true);
        return () => document.removeEventListener('click', handleClick, true);
    }, []);

    const filteredBy = homeState?.selectedPill ? homeState?.selectedPill : 'Select Primary Pill';

    return (
        <>
            <div className="relative" ref={myRef}>
                <button
                    disabled={!greenPillNFTsHoldByWalletAddress?.length}
                    onClick={() => setOpen((prev) => !prev)}
                    type="button"
                    className={` px-4 py-2 flex items-center gap-2 w-[12.5rem]  rounded-md  justify-between ${
                        !greenPillNFTsHoldByWalletAddress?.length ? 'cursor-not-allowed bg-[#6E7C78]' : 'bg-[#CBE5E1]'
                    } text-[#081B17]`}
                >
                    <span className="flex items-center justify-center gap-2">
                        {loading ? (
                            <div className="flex w-full flex-1 items-center justify-center">
                                <Loader w="w-6" h="h-6" fillColor="fill-[#326F58]" />
                            </div>
                        ) : homeState?.selectedPill ? (
                            filteredBy?.name
                        ) : (
                            filteredBy
                        )}
                    </span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.412691 3.18382L4.02209 6.79322C4.56559 7.33672 5.44356 7.33672 5.98706 6.79322L9.59646 3.18382C10.4605 2.30586 9.8473 0.800781 8.60701 0.800781L1.40214 0.800781C0.147908 0.800781 -0.465272 2.30586 0.412691 3.18382Z"
                                fill={!greenPillNFTsHoldByWalletAddress?.length ? '#535452' : '#969696'}
                            />
                        </svg>
                    </span>
                </button>

                <div
                    className={`z-[2000] w-[18.5rem] ${
                        open ? 'absolute' : 'hidden'
                    } bg-[#E1EEEC]  overflow-auto max-h-[28vh] main rounded-lg rounded-t-none shadow px-4 py-3 pt-0`}
                >
                    <div>
                        <div className="sticky top-0 bg-[#E1EEEC]   z-10 ">
                            <p className="text-[#676767] text-sm pt-3">
                                You need to select a primary pill to which all your impact points will be directed
                            </p>
                        </div>
                        <RadioButtonComponentLandscapes
                            className={'flex-col mt-2'}
                            selectedOption={homeState?.selectedPill ? filteredBy : homeState?.selectedPill}
                            onSelectOption={(option) => {
                                // const found = greenPillNFTsHoldByWalletAddress?.find(({ name }) => name === option);
                                const found = greenPillNFTsHoldByWalletAddress?.find(
                                    ({ chainName, contractAddress, tokenId }) =>
                                        chainName + contractAddress + tokenId ===
                                        option?.chainName + option?.contractAddress + option?.tokenId
                                );

                                setFoundPill(found);
                                // putSelectedPill(found);
                                setOpen(false);
                            }}
                            options={greenPillNFTsHoldByWalletAddress}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default SelectPrimaryPill;
